import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useUserAccessDetails = (curtinId: string = '') => {
  return trpc.admin.getUserAccessDetails.useQuery(
    { curtinId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
    },
  );
};
